// AI Generated File
import { Injectable } from '@angular/core';
import { IntercomService } from '@client/app/modules/chat/intercom/services/intercom.service';

@Injectable({
    providedIn: 'root',
})
export class BehaviorService {
    constructor (private intercomService: IntercomService) {}

    updatePolicy (name: string): void {
        this.intercomService.trackEvent('update-policy', { name: name });
    }

    addPolicy (name: string): void {
        this.intercomService.trackEvent('add-policy', { name: name });
    }

    userChangeAdmin (email: string, customerAdmin: boolean): void {
        this.intercomService.trackEvent('update-user-admin', { email: email, customer_admin: customerAdmin });
    }

    updateDomainGroup (domain: string, group: string): void {
        this.intercomService.trackEvent('update-domain-group', { domain: domain, group: group });
    }

    addDomainGroup (domain: string, group: string): void {
        this.intercomService.trackEvent('add-domain-group', { domain: domain, group: group });
    }

    openIntercom (): void {
        this.intercomService.trackEvent('open-intercom-chat');
    }

    addUser (email: string, customerAdmin: boolean): void {
        this.intercomService.trackEvent('add-user', { email: email, customer_admin: customerAdmin });
    }

    deleteUser (email: string): void {
        this.intercomService.trackEvent('delete-user', { email: email });
    }

    addNewDomain (url: string, title: string): void {
        this.intercomService.trackEvent('add-domain', { url: url, title: title });
    }

    createAdmin (email: string): void {
        this.intercomService.trackEvent('add-admin', { email: email });
    }

    openFasttrack (): void {
        this.intercomService.trackEvent('open-fasttrack');
    }

    fasttrackIgnore (id: string): void {
        this.intercomService.trackEvent('fasttrack-ignore', { check_id: id });
    }

    fasttrackReview (id: string): void {
        this.intercomService.trackEvent('fasttrack-review', { check_id: id });
    }

    remediationBtnClick (url: string, title: string): void {
        this.intercomService.trackEvent('remediation-button-click', { url: url, title: title });
    }

    remediationCreated (url: string, title: string): void {
        this.intercomService.trackEvent('remediation-created', { url: url, title: title });
    }

    remediationMultiBtnClick (files: any): void {
        this.intercomService.trackEvent('remediation-multi-button-click', { files: files });
    }
}
